import cookiesService from "@/services/cookiesService";
import axios from "axios";
import { API_URL } from "@/constants";
import { handleError } from "./helpers";
import { handleApiError } from "./errorHandler";

const cookiesServiceInstance = cookiesService.getService();
export let source;

// Функция для вывода SP calls в консоль
const logSpCalls = (spCallsHeader) => {
  // Проверяем настройку из localStorage
  const showLogs = localStorage.getItem('show_sp_logs') === 'true'
  if (!showLogs || !spCallsHeader) return
  
  try {
    // Декодируем RFC 2047 encoded header (=?utf-8?b?...?=)
    let decodedHeader = spCallsHeader
    if (spCallsHeader.startsWith('=?') && spCallsHeader.endsWith('?=')) {
      // Извлекаем base64 часть из =?utf-8?b?BASE64?=
      const match = spCallsHeader.match(/=\?utf-8\?b\?(.+)\?=/i)
      if (match) {
        decodedHeader = atob(match[1])
      }
    }
    
    const spCalls = JSON.parse(decodedHeader)
    
    // Выводим в консоль разработчика
    if (Array.isArray(spCalls) && spCalls.length > 0) {
      console.group(
        `%c🗄️ SP Calls (${spCalls.length})`,
        'color: #1565c0; font-weight: bold; font-size: 12px;'
      )
      
      spCalls.forEach((call, index) => {
        const timeColor = call.execution_time > 1000 ? '#f44336' : 
                         call.execution_time > 500 ? '#ff9800' : '#4caf50'
        
        const icon = call.error ? '❌' : '✅'
        
        console.log(
          `${icon} %c${call.method}%c ${call.execution_time}ms`,
          'color: #1565c0; font-weight: bold;',
          `color: ${timeColor}; font-weight: bold;`
        )
        
        if (call.args && call.args !== '[]') {
          console.log('   📋 Args:', call.args)
        }
        
        if (call.error) {
          console.error('   ⚠️ Error:', call.error)
        }
      })
      
      console.groupEnd()
    }
  } catch (e) {
    console.error('[SP Console] Failed to parse:', e)
  }
}

const instance = (authorization = true, url = null, paramsProps = {}) => {
  let params = { throwError: false, showToast: true };
  if (paramsProps) params = { ...params, ...paramsProps };

  const CancelToken = axios.CancelToken;
  source = CancelToken.source();

  const axiosInstance = axios.create({
    baseURL: url || API_URL,
    cancelToken: paramsProps.cancelToken || source.token,
  });

  if (authorization) {
    axiosInstance.interceptors.request.use(
      (config) => {
        const jwtToken = cookiesServiceInstance.getAccessToken();
        if (!!jwtToken) config.headers.Authorization = `Bearer ${jwtToken}`;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }
  axiosInstance.interceptors.response.use(
    (response) => {
      // Перехватываем SP вызовы из headers
      logSpCalls(response.headers['x-sp-calls'])
      return response
    },
    (error) => {
      // Перехватываем SP вызовы из headers даже при ошибке
      if (error.response?.headers) {
        logSpCalls(error.response.headers['x-sp-calls'])
      }
      
      if (axios.isCancel(error)) {
        return Promise.resolve();
      }
      if (parseInt(error.response?.status) === 401) {
        return handleError(error);
      }

      const skipToast = error.config?._skipErrorToast === true;
      return handleApiError(error, {
        showToast: skipToast ? false : params?.showToast,
        throwError: skipToast || params?.throwError,
      });
    }
  );
  return axiosInstance;
};

export default instance;
